import { render, staticRenderFns } from "./PagedGrid.vue?vue&type=template&id=46c0ade4&scoped=true&"
import script from "./PagedGrid.vue?vue&type=script&lang=js&"
export * from "./PagedGrid.vue?vue&type=script&lang=js&"
import style0 from "./PagedGrid.vue?vue&type=style&index=0&id=46c0ade4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0ade4",
  null
  
)

export default component.exports